<template>
  <transition name="slide-in-up" appear appear-active-class="animated slideInUp">
    <v-footer id="footer" class="no-select" fixed app dir="ltr" style="dir:ltr;">
      <div id="footer-info">
        <span id="copyrights">&copy;{{ fullYear }}&nbsp; KEENTECH&nbsp;</span>

        <v-tooltip top v-for="footerIcon in footerIcons" :key="footerIcon.icon">
          <v-btn icon slot="activator" :href="footerIcon.link" target="_blank">
            <v-icon>{{ footerIcon.icon }}</v-icon>
          </v-btn>
          <span>{{ $t(footerIcon.tooltip) }}</span>
        </v-tooltip>
      </div>
    </v-footer>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Footer',

  data() {
    return {
      fullYear: null
    }
  },

  computed: {
    ...mapGetters({
      footerIcons: 'misc/getFooterIcons'
    })
  },

  mounted() {
    let theDate = new Date()
    this.fullYear = theDate.getFullYear()
  }
}
</script>

<style scoped>
#footer {
  background: rgba(1, 42, 61, 0.7);
  color: white;
  padding-left: 10px;
  padding-right: 10px;
}

#copyrights {
  font-family: 'roborto', Helvetica, Arial, sans-serif !important;
  position: relative;
  top: 1px;
}
.application--is-rtl #copyrights {
  top: -1px;
}

.v-btn {
  margin: 0;
}
.v-btn .v-icon {
  color: white;
  font-weight: normal;
  font-size: 18px !important;
}
.v-btn::focus .v-icon {
  color: white;
  background-color: yellow;
}

#footer-info {
  margin: 0 auto;
  animation-duration: 0.5s;
}
</style>
